import React, { useEffect } from 'react';
import {
    MDBCard,
    MDBCardBody,
    MDBCardText,
    MDBCardImage,
    MDBContainer,
    MDBIcon,
    MDBBtn,
} from "mdb-react-ui-kit";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { getRelatedTours, getTour } from '../redux/features/tourSlice';
import RelatedTours from '../components/RelatedTours';
import DisqusThread from '../components/DisqusThread';
import { BsFillArrowLeftCircleFill } from 'react-icons/bs'

const SingleTour = () => {

    const dispatch = useDispatch();
    const { tour, relatedTours } = useSelector((state) => ({ ...state.tour }));
    const { id } = useParams();
    const navigate = useNavigate();
    const tags = tour?.tags;


    useEffect(() => {
        tags && dispatch(getRelatedTours(tags))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tags])

    useEffect(() => {
        if (id) {
            dispatch(getTour(id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
    return (
        <>
            <MDBContainer>
                <MDBCard style={{ marginTop: '80px' }} className="mb-3">
                    <MDBCardImage
                        position="top"
                        style={{ width: "100%", maxHeight: "600px" }}
                        src={tour.imageFile}
                        alt={tour.title}
                    />
                    <MDBCardBody>
                        <MDBBtn
                            tag="a"
                            color="none"
                            style={{ float: "left", color: "#000" }}
                            onClick={() => navigate("/")}
                        >
                            {/* <MDBIcon
                                fas
                                size="lg"
                                icon="long-arrow-alt-left"
                                style={{ float: "left" }}
                            /> */}
                            <BsFillArrowLeftCircleFill className='fs-3' />
                        </MDBBtn>
                        <h3>{tour.title}</h3>
                        <span>
                            <p className="text-start tourName">Created By: {tour.name}</p>
                        </span>
                        <div style={{ float: "left" }}>
                            <span className="text-start">
                                {tour && tour.tags && tour.tags.map((item, index) => `#${item} `)}
                            </span>
                        </div>
                        <br />
                        <MDBCardText className="text-start mt-2">
                            <MDBIcon
                                style={{ float: "left", margin: "5px" }}
                                far
                                icon="calendar-alt"
                                size="lg"
                            />
                            <small className="text-muted">
                                {moment(tour.createdAt).fromNow()}
                            </small>
                        </MDBCardText>
                        <MDBCardText className="lead mb-0 text-start">
                            {tour.description}
                        </MDBCardText>
                    </MDBCardBody>
                </MDBCard>
                <DisqusThread id={id} title={tour.title} path={`/tour/${id}`} />
                <RelatedTours relatedTours={relatedTours} tourId={id} />
            </MDBContainer>
        </>
    );
};

export default SingleTour;